import type { AxiosRequestConfig } from "axios";
import axios from "../utils/axios";
import { LocalStorageKey } from "../constants/localStorageKeys";

const getStaticConfig = (): any =>
{
  try
  {
    const raw = localStorage.getItem(LocalStorageKey.STATIC_CONFIG);
    return raw ? JSON.parse(raw) : {};
  } catch (error)
  {
    return {};
  }
};

/**
 * Build a full VMRS URL from config:
 *   REACT_APP_API_BASE_URL + "/" + REACT_APP_API_SERVICE_PREFIX_VMRS + path
 * e.g. buildVmrsUrl("/api/v1/workflows") -> "https://api.geohub.vn/v1/vmrs/api/v1/workflows"
 */
export const buildVmrsUrl = (path: string): string =>
{
  const cfg = getStaticConfig();
  const base = String(cfg?.REACT_APP_API_BASE_URL ?? "").replace(/\/+$/, "");
  const prefix = cfg?.REACT_APP_API_SERVICE_PREFIX_VMRS || "vmrs";
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}/${prefix}${p}`;
};

/**
 * Common VMRS GET — uses REACT_APP_API_BASE_URL + REACT_APP_API_SERVICE_PREFIX_VMRS.
 * Auth headers are added by the shared axios interceptor.
 *   vmrsGet("/api/v1/workflows/type/order_tasking/provider/17")
 */
export const vmrsGet = <T = any>(path: string, config?: AxiosRequestConfig) =>
{
  return axios.get<T>(buildVmrsUrl(path), config);
};

export const vmrsPost = <T = any>(
  path: string,
  data?: any,
  config?: AxiosRequestConfig,
) =>
{
  return axios.post<T>(buildVmrsUrl(path), data, config);
};

export const vmrsPut = <T = any>(
  path: string,
  data?: any,
  config?: AxiosRequestConfig,
) =>
{
  return axios.put<T>(buildVmrsUrl(path), data, config);
};

export const vmrsPatch = <T = any>(
  path: string,
  data?: any,
  config?: AxiosRequestConfig,
) =>
{
  return axios.patch<T>(buildVmrsUrl(path), data, config);
};

export const vmrsDelete = <T = any>(path: string, config?: AxiosRequestConfig) =>
{
  return axios.delete<T>(buildVmrsUrl(path), config);
};
